import React from 'react';

const PeopleTile = ({ item }) => {
    return (
        <div className="component-people-tile tile">
            <a href={item.url}>
                <div className="image-container">
                    <img src={item.thumbnail} alt={`${item.title} head shot`} />
                    <div className="overlay"></div>
                </div>
                <p>{item.title}</p>
            </a>
        </div>
    );
};

PeopleTile.propTypes = {
    item: React.PropTypes.object.isRequired
};

export default PeopleTile;



/** WEBPACK FOOTER **
 ** ./src/components/tiles/people-tile/PeopleTile.jsx
 **/